module.exports = __webpack_public_path__ + "static/media/Payments.54aad320.png";